import { enc } from "crypto-js";
export function hex2base64(input) {
    return enc.Base64.stringify(enc.Hex.parse(input));
}
export function base642hex(input) {
    return enc.Base64.parse(input).toString(enc.Hex);
}
export function utf82base64(input) {
    return enc.Utf8.stringify(enc.Base64.parse(input));
}
export function base642utf8(input) {
    return enc.Base64.parse(input).toString(enc.Utf8);
}
//# sourceMappingURL=base64.js.map